import createModalSkeleton from "src/helpers/createModalSkeleton";

const { useImageCropModalDimensions } = createModalSkeleton({
	name: "ImageCropModal",
	sizeVariant: "Large",
});

export { useImageCropModalDimensions };
